import { render, staticRenderFns } from "./ParticipanPageKMI.vue?vue&type=template&id=37a1e354&"
import script from "./ParticipanPageKMI.vue?vue&type=script&lang=js&"
export * from "./ParticipanPageKMI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports